import { defineSlotRecipe } from "@chakra-ui/react";

const drawerSlotRecipe = defineSlotRecipe({
    slots: [
        "root",
        "backdrop",
        "positioner",
        "content",
        "header",
        "body",
        "footer",
        "title",
        "description",
        "closeTrigger"
    ],
    className: "chakra-drawer",
    base: {
        backdrop: {},
        positioner: {},
        content: {},
        header: {},
        body: {},
        footer: {},
        title: {},
        description: {},
        closeTrigger: {}
    }
});

export default drawerSlotRecipe;
